import { ApplicantOfferRequirementTask } from 'types';

const rendererHandlesTaskText = new Set<ApplicantOfferRequirementTask>([
  ApplicantOfferRequirementTask.RecordedInterview,
]);

const rendererSkipsPrefix = new Set<ApplicantOfferRequirementTask>([
  ApplicantOfferRequirementTask.CalendlyInterview,
  ApplicantOfferRequirementTask.RecordedInterview,
]);

export function doesRendererHandleTaskText(taskType?: ApplicantOfferRequirementTask): boolean {
  return !!taskType && rendererHandlesTaskText.has(taskType);
}

export function doesRendererSkipPrefix(taskType?: ApplicantOfferRequirementTask): boolean {
  return !!taskType && rendererSkipsPrefix.has(taskType);
}
